import { BrowserModule } from '@angular/platform-browser';
import { ErrorHandler, NgModule } from '@angular/core';
import { IonicApp, IonicErrorHandler, IonicModule } from 'ionic-angular';
import { HttpModule } from '@angular/http';

import { IonicStorageModule } from '@ionic/storage';

/* Importando o Push do phonegap */
import { Push } from '@ionic-native/push';
// import { Badge } from '@ionic-native/badge';

/* Escolher a lingua */
import { LinguaPage } from '../pages/lingua/lingua';

/* Ligar para numero */
import { CallNumber } from '@ionic-native/call-number';

/* Enviar email */
// import { EmailComposer } from '@ionic-native/email-composer';

/* Importa as variáeis das páginas */
import { MyApp } from './app.component';
import { HomePage } from '../pages/home/home';
import { HomeenderecoPage } from '../pages/home/home';
import { TutorialqrcodePage } from '../pages/home/home';
import { MaisempresaPage } from '../pages/home/home';
import { LoginPage } from '../pages/login/login';
import { LoginpadraoPage } from '../pages/loginpadrao/loginpadrao';
import { RegisterPage } from '../pages/register/register';
import { EsqueceusenhaPage } from '../pages/esqueceusenha/esqueceusenha';
import { CartaofidelidadePage } from '../pages/cartaofidelidade/cartaofidelidade';
import { MensagemPontoPage } from "../pages/mensagem-ponto/mensagem-ponto";
import { DadosPage } from '../pages/dados/dados';
import { NotificacoesPage } from '../pages/notificacoes/notificacoes';
import { EmpresaPage } from '../pages/empresa/empresa';
import { RegrasPage } from '../pages/regras/regras';
import { MensagensPage } from '../pages/mensagens/mensagens';
import { HistoricoPage } from '../pages/historico/historico';
import { SobrePage } from '../pages/sobre/sobre';
import { TabsPage } from '../pages/tabs/tabs';
import { PopoverPage } from '../pages/tabs/tabs';


import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

/* Mapa */
import { LaunchNavigator } from '@ionic-native/launch-navigator';

/* Compartilhar */
import { SocialSharing } from '@ionic-native/social-sharing';

/* Ionic Native */
import { AppVersion } from '@ionic-native/app-version';

/* Importa providers*/
import { ApiProvider } from '../providers/api/api';
import { AuthProvider } from '../providers/auth/auth';
import { NotificacaoComponent } from '../components/notificacao/notificacao';
// import { ShareComponent } from '../components/share/share';
// import { SharePopoverPage } from '../components/share/share';

/* QRCode */
// import { QRScanner } from '@ionic-native/qr-scanner';

/* Login facebook */
import { Facebook } from '@ionic-native/facebook';

/* Tradução */
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
import { TranslateMsgProvider } from '../providers/translate-msg/translate-msg';

/* Chat */
import { SocketIoModule, SocketIoConfig } from 'ng-socket-io';
// Url onde o node ja está ouvindo
// const config: SocketIoConfig = { url: 'https://localhost:3001', options: {} };
// const config: SocketIoConfig = { url: 'https://homologa.cartaofidelidadedigital.com.br:49170', options: {secure: true} };
const config: SocketIoConfig = { url: 'https://assinante.cartaofidelidadedigital.com.br:49170', options: {secure: true} };
import { ChatProvider } from '../providers/chat/chat';


@NgModule({
  declarations: [
    MyApp,
    HomePage,
    HomeenderecoPage,
    TutorialqrcodePage,
    MaisempresaPage,
    LoginPage,
    LoginpadraoPage,
    RegisterPage,
    EsqueceusenhaPage,
    CartaofidelidadePage,
    MensagemPontoPage,
    DadosPage,
    NotificacaoComponent,
    NotificacoesPage,
    EmpresaPage,
    RegrasPage,
    MensagensPage,
    HistoricoPage,
    SobrePage,
    TabsPage,
    PopoverPage,
    LinguaPage,
    // ShareComponent,
    // SharePopoverPage
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp, {
        tabsHideOnSubPages:false
    }),
    IonicStorageModule.forRoot(),
    HttpModule,
    HttpClientModule,
    SocketIoModule.forRoot(config),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    HomeenderecoPage,
    TutorialqrcodePage,
    MaisempresaPage,
    LoginPage,
    LoginpadraoPage,
    RegisterPage,
    EsqueceusenhaPage,
    CartaofidelidadePage,
    MensagemPontoPage,
    DadosPage,
    NotificacoesPage,
    EmpresaPage,
    RegrasPage,
    MensagensPage,
    HistoricoPage,
    SobrePage,
    TabsPage,
    PopoverPage,
    LinguaPage,
    // SharePopoverPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ApiProvider,
    Facebook,
    // Badge,
    AuthProvider,
    CallNumber,
    // EmailComposer,
    LaunchNavigator,
    SocialSharing,
    AppVersion,
    Push,
    // QRScanner,
    TranslateMsgProvider,
    ChatProvider
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts